import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { ImageCroppedEvent, ImageCropperComponent as ImageCropperComponent_1 } from 'ngx-image-cropper';
import { FormGroup } from '@angular/forms';
import { acceptedFileUploadImageFileExtensions, fileImageUploadAcceptTypes, maxFileUploadSizeBytes } from 'src/app/shared/constants';
import { isFileExtensionValid, isFileSizeValid } from '../../form/dynamic-form/dynamic-form-field/validators/validators.model';
import { OutputFormat } from 'ngx-image-cropper';

@Component({
    selector: 'app-image-cropper',
    templateUrl: './image-cropper.component.html',
    imports: [ImageCropperComponent_1]
})
export class ImageCropperComponent implements OnInit, OnChanges {
    @Input() fileChangedEvent: any;
    @Input() icMaintainAspectRatio = true;
    @Input() icAspectRatio: number = 4 / 3;
    @Input() icFormat: OutputFormat = 'png';
    @Input() icNotes: string;
    @Input() icMaxFileSize = maxFileUploadSizeBytes;
    @Input() icAcceptTypes = fileImageUploadAcceptTypes;
    @Input() loading = false;

    icImageName: string;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    uploadedImage: File;

    icError = false;
    form: FormGroup;
    errors: string[] = [];

    @Output() finalImage = new EventEmitter();

    constructor() {}

    ngOnInit(): void {
    	this.icError = false;
    	if (this.fileChangedEvent) {
    		this.newImage(this.fileChangedEvent);
    	}
    }

    ngOnChanges(): void {}

    imageCropped(event: ImageCroppedEvent): void {
    	this.croppedImage = event.base64;
    }
    imageLoaded(): void {
    	// show cropper
    }
    cropperReady(): void {
    	// cropper ready
    }
    loadImageFailed(): void {
    	// show message
    }
    finalizeCroppedImage(): void {
    	const imageBlob = this.base64ToFile(this.croppedImage);
    	imageBlob.name = this.icImageName + '.' + this.icFormat;
    	this.finalImage.emit(imageBlob);
    }
    base64ToFile(base64Image: string): any {
    	const split = base64Image.split(',');
    	const type = split[0].replace('data:', '').replace(';base64', '');
    	const byteString = atob(split[1]);
    	const ab = new ArrayBuffer(byteString.length);
    	const ia = new Uint8Array(ab);
    	for (let i = 0; i < byteString.length; i += 1) {
    		ia[i] = byteString.charCodeAt(i);
    	}
    	return new Blob([ab], { type });
    }
    newImage(event: any): void {
    	// Setting imageChangedEvent to null resets the cropper
    	this.imageChangedEvent = null;
    	this.errors = [];
    	this.icError = false;

    	this.imageChangedEvent = event;

    	this.uploadedImage = this.imageChangedEvent.target.files[0];

    	if (this.uploadedImage) {
    		this.icFormat = this.uploadedImage.type.replace('image/', '') as OutputFormat;

    		if (!isFileExtensionValid(this.uploadedImage, acceptedFileUploadImageFileExtensions)) {
    			this.errors.push('Photo must be in one of the following formats: .jpg, .jpeg, .png, .gif');
    			this.icError = true;
    			this.imageChangedEvent = null;
    		} else if (!isFileSizeValid(this.uploadedImage, this.icMaxFileSize)) {
    			this.errors.push('Photo must be less than 10MB.');
    			this.icError = true;
    			this.imageChangedEvent = null;
    		}

    		this.icImageName = this.uploadedImage.name.split('.')[0];
    	}
    }
}
